import Loadable, { NullLoader } from '@comeon/loadable';

// Make all the containers loadable under single chunk.

const SportsbookLeaguePageContainer = Loadable({
	loader: () =>
		import(
			/* webpackChunkName: "sportsbook-league-page" */
			'./sportsbook-league-page-container'
		),
	loading: NullLoader
});

const SportsbookLeagueEventsContainer = Loadable({
	loader: () =>
		import(
			/* webpackChunkName: "sportsbook-league-page" */
			'./league-events/sportsbook-league-events-container'
		),
	loading: NullLoader
});

const SportsbookLeagueOutrightsContainer = Loadable({
	loader: () =>
		import(
			/* webpackChunkName: "sportsbook-league-page" */
			'./outrights/sportsbook-league-outrights-container'
		),
	loading: NullLoader
});

const SportsbookLeagueTournamentPreviewContainer = Loadable({
	loader: () =>
		import(
			/* webpackChunkName: "sportsbook-league-page" */
			'./widgets/sportsbook-league-tournament-preview-container'
		),
	loading: NullLoader
});

export {
	SportsbookLeaguePageContainer,
	SportsbookLeagueEventsContainer,
	SportsbookLeagueOutrightsContainer,
	SportsbookLeagueTournamentPreviewContainer
};
